import { createSelector } from 'reselect';

import { RequestState } from './utils/state-manager';

export type JobRoleState = {
  jobRoles: Array<JobRole>;
  jobRolesState: RequestState;
};
type State = { jobRoles: JobRoleState };

export const jobRolesStateSelector = (state: State) => state.jobRoles.jobRolesState;

export const jobRolesSelector = (state: State) => state.jobRoles.jobRoles;
export const jobRoleSelector = createSelector(
  [jobRolesSelector, (_state: State, jobRoleId: number) => jobRoleId],
  (jobRoles, jobRoleId) => jobRoles?.find((jobRole) => jobRole.jobRoleId === jobRoleId),
);
